import React from 'react';

import { UnkeyedCategory } from '@/hooks/useGetStructuredBrowseData';

import Constants from '@/constants';

import { ProcedureStep } from '../AddProcedurePopup';
import { PROCEDURE_STEPS } from '../constants';

import CategoryCard from '@/routes/Explore/Operations/components/CategoryCard';
import CategorySection from '@/routes/Explore/Operations/components/CategorySection';

interface Step1Props {
  categories: UnkeyedCategory[];
  featured: UnkeyedCategory[];
  setCategorySelected: (category: UnkeyedCategory | null) => void;
  setSearchTermDisplayed: (value: string) => void;
  setActiveStep: (step: ProcedureStep) => void;
}

const StepOneCategories: React.FC<Step1Props> = ({
  categories,
  featured,
  setCategorySelected,
  setSearchTermDisplayed,
  setActiveStep,
}) => {
  const renderCategoryList = (
    sectionTitle: string,
    categoryList?: UnkeyedCategory[],
  ) => {
    if (!categoryList?.length) {
      return null;
    }
    return (
      <CategorySection data-testid="featuredWrapper" section={sectionTitle}>
        {categoryList.map(item => (
          <CategoryCard
            categoryIcon={item.icon}
            categoryId={item.id}
            categoryName={item.name}
            key={item.id}
            onClick={() => {
              setActiveStep(PROCEDURE_STEPS.SUBCATEGORIES);
              setCategorySelected(item);
              setSearchTermDisplayed('');
            }}
          />
        ))}
      </CategorySection>
    );
  };

  return (
    <>
      {renderCategoryList(Constants.CATEGORY_SECTION_NAME.FEATURED, featured)}
      {renderCategoryList(
        Constants.CATEGORY_SECTION_NAME.CATEGORIES,
        categories,
      )}
    </>
  );
};

export default StepOneCategories;
